var AvatarPatch = function(props) {
	var patch = props.patch;
	var patchType = patch["patch_type"];
	var patchPath = "patches/" + patch["patch_directory"] + "/" + patch["name"];
	if (props.color !== undefined) {
		patchPath += "-" + props.color;
	}
	patchPath = dynamicRequire(patchPath + ".png");

	var patchStyle = {
		position: "absolute",
		display: "block",
		top: 0,
		left: 0,
		width: "100%",
		height: "100%",
	};

	if (props.offsets) {
		if (patchType == "hand") {
			patchStyle["left"] = props.offsets["right_x"] + "px";
			patchStyle["top"] = props.offsets["right_y"] + "px";
		} else if (patchType == "left_hand") {
			patchStyle["left"] = props.offsets["left_x"] + "px";
			patchStyle["top"] = props.offsets["left_y"] + "px";
		}
	}
	patchStyle["zIndex"] = patch["z_index"];

	return (
		<img src={ patchPath } style={ patchStyle } data-color={ props.color } data-patch={ patchType }/>
	)
};

AvatarPatch.propTypes = StrictPropTypes({
	// Info on this patch, including .name and .patchType
	patch: PropTypes.object.isRequired,

	color: PropTypes.number,

	// Contains offsets for the hand
	offsets: PropTypes.object
});

AvatarPatch.WIDTH = 401;
AvatarPatch.HEIGHT = AvatarPatch.WIDTH;

AvatarPatch.DEFAULT_WIDTH = 235;
AvatarPatch.DEFAULT_HEIGHT = 210;
AvatarPatch.DEFAULT_LEFT = -(AvatarPatch.WIDTH - AvatarPatch.DEFAULT_WIDTH) / 2;
AvatarPatch.DEFAULT_TOP = (-(AvatarPatch.HEIGHT - AvatarPatch.DEFAULT_HEIGHT) / 2) + 15;

module.exports = AvatarPatch;


// WEBPACK FOOTER //
// ./modules/components/avatars/AvatarPatch.js